<!--
  The legend teaches the code by showing it: the same grain, running sparse to dense, between the
  poles of the very lexicon the rows use. It carries no numeral and no explanation, and it is
  hidden from assistive technology because each row already states its level in words.
-->
@if (rendered().length > 0) {
    <div class="sensory-legend" aria-hidden="true">
        <span class="legend-word">{{ 'editorial.intensity.1' | translate }}</span>
        <span class="legend-ramp">
            @for (cell of legendCells; track cell) {
                <i class="legend-cell" [class]="'legend-' + cell"></i>
            }
        </span>
        <span class="legend-word legend-word-high">{{ 'editorial.intensity.5' | translate }}</span>
    </div>
}

<!--
  Each row is a single labelled image for assistive technology. Reading a texture says nothing;
  "Cuerpo: Medio (3 de 5)" says everything, which is why the exact figure lives here and only
  here. The grain itself is decorative and stays hidden.
-->
<ul class="sensory-rows">
    @for (axis of rendered(); track axis.code) {
        <li class="sensory-row"
            [class]="'level-' + axis.level"
            [style.--row-extent]="axis.extent"
            role="img"
            [attr.aria-label]="axis.ariaLabel">

            <span class="row-name">{{ axis.label }}</span>

            <span class="row-strip">
                <i class="row-grain" aria-hidden="true"></i>
            </span>

            <span class="row-word">{{ axis.word }}</span>
        </li>
    }
</ul>
